/* eslint-disable ember/no-classic-components, ember/no-runloop, ember/require-tagless-components */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import Component from '@ember/component';
import { later } from '@ember/runloop';
// Internal Imports
import { getTablePrintCss } from 'linced-app/utils/table';

export default class RiskOverview extends Component {
  @tracked
  dialogOpen = false;

  @action
  openDialog() {
    this.dialogOpen = true;
  }

  @action
  print() {
    let printer = window.open(
      'about:blank',
      '_blank',
      'menubar=yes,location=no,resizable=yes,scrollbars=yes,status=no,height=700,width=1024',
    );

    let content = getTablePrintCss(false);

    content += `<h1>${this.event.get('title')}</h1>`;

    content += this.event.riskMitigations;

    printer.document.body.innerHTML = content;

    later(
      this,
      (printer) => {
        printer.print();
        printer.close();
      },
      printer,
      500,
    );
  }
}
